import { createUseQueryHook } from './createUseQueryHook';

export const useCompanyDetails = createUseQueryHook('employee_company_details', {
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
});
